import { FormEvent } from "react";
import useListRowInfStroe from "store/listRowInf";
import {
  initialFilterStateProps,
  useProductHistoryFilterContext,
  useProductHistoryParamsContext,
} from "./context";

// 조회 parm

export const useSubmit = () => {
  const { setParam } = useProductHistoryParamsContext();
  const { filters } = useProductHistoryFilterContext();

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    let param = {} as initialFilterStateProps;

    (Object.keys(filters) as Array<keyof initialFilterStateProps>).forEach(
      (key) => {
        const value = filters[key];
        if (!value) return;
        if (!!value) {
          param = {
            ...param,
            [key]: value,
          };
        }
      }
    );

    setParam(param);
  };

  return {
    onSubmit,
  };
};

// 상세모달 오픈
export const detail = (props: any) => {
  const setListRowParams = useListRowInfStroe.getState().setListRowParams;

  const params = {
    no: props.data.rmPdHistNo,
    rgSeq: 1,
    btnNm: props.colDef.field,
  };

  setListRowParams(params);
};
